import { addNetworkStateListener, getNetworkStateAsync, useNetworkState } from 'expo-network';
import { Platform } from 'react-native';

/**
 * Connectivity helpers. "Unknown" is treated as online so a slow probe never
 * blocks normal behaviour; only a definite "no" flips the app into offline
 * mode.
 */
function isOnlineFromState(state: { isConnected?: boolean; isInternetReachable?: boolean }): boolean {
  if (state.isConnected === false) return false;
  if (state.isInternetReachable === false) return false;
  return true;
}

export function useIsOnline(): boolean {
  const state = useNetworkState();
  if (Platform.OS === 'web') return true;
  return isOnlineFromState(state);
}

export async function getIsOnline(): Promise<boolean> {
  if (Platform.OS === 'web') return true;
  try {
    return isOnlineFromState(await getNetworkStateAsync());
  } catch {
    return true;
  }
}

/** Calls `cb(online)` on every change. Returns an unsubscribe function. */
export function subscribeOnline(cb: (online: boolean) => void): () => void {
  if (Platform.OS === 'web') return () => {};
  const sub = addNetworkStateListener((state) => cb(isOnlineFromState(state)));
  return () => sub.remove();
}
